import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';

LP.UI.Popup = {
  create: function (id, width, height, onLoad) {
    var popupId = 'lp_popup_' + id;

    var popup = $('<div class="lp-popup" id="' + popupId + '"></div>');
    if (width) popup.css('width', width);
    if (height) popup.css('height', height);

    popup.hide();
    $('body').prepend(popup);

    if (is_function(onLoad)) {
      onLoad(popupId);
    } else {
      popup.show();
    }

    return popupId;
  },
};
